module.exports = __webpack_public_path__ + "assets/fonts/Nunito-VariableFont_wght.ea0ad4c7.ttf";